<template>
  <div>
    <default-dialog :loading="loading" fullscreen>
      <template slot="title">
        {{ supplier?.data?.attributes?.product_name }}
      </template>
      <template slot="content">
        <v-container>
          <v-card v-if="!loading" class="mt-3">
            <v-card-title class="d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-icon size="19" color="red" class="mr-2">mdi-currency-usd</v-icon>
                <span class="red--text font-weight-bold text-subtitle-1">Preços</span>
              </div>
              <f-btn edit :disabled="!user_allowed" @click="openEditDialog"></f-btn>
            </v-card-title>
            <v-card-text>
              <card-loading-transparent v-if="saving" loadingText="Salvando"></card-loading-transparent>
              <v-data-table
                v-if="!saving && activePrices.length > 0"
                :headers="priceHeaders"
                :items="activePrices"
                :items-per-page="10"
                class="elevation-0"
                hide-default-footer
              >
                <template v-slot:item.price="{ item }">
                  <span class="font-weight-bold">R$ {{ item.price }}</span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :color="item.status_id === 1 ? 'green' : 'red'"
                    :text-color="item.status_id === 1 ? 'white' : 'white'"
                    small
                  >
                    {{ item.status_id === 1 ? 'Habilitado' : 'Desabilitado' }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    :color="item.status_id === 1 ? 'red' : 'green'"
                    dark
                    small
                    :disabled="!user_allowed"
                    @click="toggleStatus(item)"
                  >
                    {{ item.status_id === 1 ? 'Desabilitar' : 'Habilitar' }}
                  </v-btn>
                </template>
              </v-data-table>
              <v-alert v-else-if="!saving" type="info" outlined>
                Nenhum preço cadastrado
              </v-alert>
            </v-card-text>
          </v-card>
        </v-container>
        <v-dialog v-model="edit_price" scrollable persistent :overlay="true" max-width="800px" transition="dialog-transition" v-if="edit_price">
          <v-card>
            <v-card-title>
              <span class="headline">Criando/Editando preços</span>
            </v-card-title>
            <v-card-text>
              <v-col cols='12'>
                <v-row v-for="brandCompanyCode in brandCompanyCodesForEdit" :key="brandCompanyCode.id">
                  <v-col cols='12' sm='6'>
                    <v-checkbox 
                      :label="`${brandCompanyCode.company_name} (Código: ${brandCompanyCode.code})`" 
                      v-model="brandCompanyCode.active"
                    ></v-checkbox>
                    <v-chip 
                      v-if="brandCompanyCode.hasExistingPrice" 
                      small 
                      color="info" 
                      class="ml-4"
                    >
                      Preço existente: R$ {{ brandCompanyCode.existingPrice }}
                    </v-chip>
                  </v-col>
                  <v-col cols='12' sm='6'>
                    <v-text-field 
                      label="Preço (R$)" 
                      v-model="brandCompanyCode.price" 
                      :disabled="!brandCompanyCode.active" 
                      v-money="money"
                      :placeholder="brandCompanyCode.hasExistingPrice ? `Preço atual: R$ ${brandCompanyCode.existingPrice}` : 'Digite o preço'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols='12' hidden-sm-and-up>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <f-btn @click="edit_price = false" cancel></f-btn>
              <f-btn @click="startUpdateSupplier('prices')" save></f-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    
    
        
      </template>
      <template slot="actions">
        <f-btn text @click="closeEditProductPickupLocation" close></f-btn>
      </template>
    </default-dialog>



  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import { VMoney } from 'v-money'
import Api from '@/api/index';
import getters from "@/_backoffice/_registrations/mixins/getters.js"
import validations from "@/mixins/validations";

export default {
  name: 'EditProductPickupLocation',
  directives: { money: VMoney },
  mixins: [getters, validations],
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
      edit_price: false,
      loading: true,
      supplier: {},
      dialog: true,
      saving: false,
      had_item_updated: false,
      nameChanged: false,
      productPrices: [],
      brandCompanyCodes: [],
      brandCompanyCodesForEdit: [],
      priceHeaders: [
        { text: 'Empresa', value: 'company_name', sortable: false },
        { text: 'Valor', value: 'price', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  methods: {
    async getData() {
      this.loading = true
      try {
        // Get product pickup location info
        const locationData = await this.getProductPickupLocation()
        this.supplier = locationData
        
        // Get product prices for this location
        await this.getProductPrices()
      } catch (err) {
        console.log(err)
        this.addNotification({type: 'error', msg: 'Erro ao carregar dados'})
      } finally {
        this.loading = false
      }
    },
    async getProductPickupLocation() {
      try {
        const response = await Api.Supplier.show({ 
          id: this.$route.params.id, 
          type: 'product_pickup_locations' 
        })
        return response.data
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    async getProductPrices() {
      try {
        const response = await Api.ProductPrice.index({
          product_pickup_location_id: this.$route.params.id,
          list_all: true
        })
        // The response is already an array, no need for .data.data
        this.productPrices = response.data || []
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    async getBrandCompanyCodes() {
      try {
        if (this.supplier?.data?.attributes?.brand_id) {
          const response = await Api.BrandCompanyCode.index({
            brand_id: this.supplier.data.attributes.brand_id
          })
          this.brandCompanyCodes = response.data || []
          
          // Buscar informações das empresas para ter os nomes
          await this.enrichBrandCompanyCodesWithCompanyNames()
        }
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    async enrichBrandCompanyCodesWithCompanyNames() {
      try {
        // Buscar todas as empresas para mapear os nomes
        const companiesResponse = await this.getCompanies()
        const companies = companiesResponse || []
        
        // Enriquecer brandCompanyCodes com nomes das empresas
        this.brandCompanyCodes = this.brandCompanyCodes.map(brandCompanyCode => {
          const company = companies.find(comp => comp.id === brandCompanyCode.company_id)
          return {
            ...brandCompanyCode,
            company_name: company ? company_name : brandCompanyCode.company_name
          }
        })
      } catch (err) {
        console.log('Erro ao buscar nomes das empresas:', err)
        // Continuar sem os nomes das empresas
      }
    },
    async openEditDialog() {
      try {
        await this.getBrandCompanyCodes()
        this.prepareBrandCompanyCodesForEdit()
        this.edit_price = true
      } catch (err) {
        console.log(err)
        this.addNotification({type: 'error', msg: 'Erro ao carregar dados para edição'})
      }
    },
    async startUpdateSupplier(kind) {
      this.swallConfirmation({
        title: 'Deseja criar novos preços?',
        icon: 'question',
      }).then(async confirmed =>{
        if (confirmed ) {
          this.saving = true
          
          try {
            if (kind == 'prices') {
              await this.updatePrices()
              this.edit_price = false
            }
            
            this.had_item_updated = true
            await this.getData()
          } catch (err) {
            console.log(err)
            this.addNotification({type: 'error', msg: `Erro: ${err}`})
          } finally {
            this.saving = false
          }
        }
      })
    },
    prepareBrandCompanyCodesForEdit() {
      this.brandCompanyCodesForEdit = this.brandCompanyCodes.map(brandCompanyCode => {
        // Verificar se já existe um preço para este brand_company_code
        const existingPrice = this.productPrices.find(price => 
          price.brand_company_code_id === brandCompanyCode.id
        )
        
        return {
          id: brandCompanyCode.id,
          company_id: brandCompanyCode.company_id,
          brand_id: brandCompanyCode.brand_id,
          code: brandCompanyCode.code,
          company_name: brandCompanyCode.company_name || `Empresa ${brandCompanyCode.company_id}`,
          active: false, // Por padrão, não está ativo
          price: existingPrice ? existingPrice.price : '', // Usar preço existente como referência
          hasExistingPrice: !!existingPrice,
          existingPrice: existingPrice ? existingPrice.price : null
        }
      })
    },
    async updatePrices() {
      // Filtrar apenas os brand_company_codes que estão ativos e têm preço
      const activeBrandCompanyCodes = this.brandCompanyCodesForEdit.filter(item => 
        item.active && item.price && parseFloat(item.price.replace(',', '')) > 0
      )
      console.log(activeBrandCompanyCodes)
      if (activeBrandCompanyCodes.length === 0) {
        this.addNotification({type: 'warning', msg: 'Nenhum preço foi selecionado para criação.'})
        return
      }
      
      // Criar novos product prices
      const productPricesToCreate = activeBrandCompanyCodes.map(item => ({
        brand_company_code_id: item.id,
        product_pickup_location_id: parseInt(this.$route.params.id),
        price: parseFloat(item.price.replace(',', '')),
        active: true,
        status_id: 1 // Sempre ativo por padrão
      }))
      
      try {
        // Criar todos os product prices de uma vez
        const response = await this.createProductPrices(productPricesToCreate)
        
        this.addNotification({type: 'success', msg: `${productPricesToCreate.length} preço(s) criado(s) com sucesso.`})
        this.nameChanged = true
        await this.getProductPrices()
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    async createProductPrices(productPricesData) {
      try {
        // Usar diretamente a API v2 do ProductPrice
        const response = await Api.SupplierV2.create('product_prices', { 
          product_prices: productPricesData
        });

        return response.data
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    async toggleStatus(item) {
      const newStatus = item.status_id === 1 ? 2 : 1
      const action = newStatus === 1 ? 'habilitar' : 'desabilitar'
      
      this.swallConfirmation({
        title: `Deseja ${action} este preço?`,
        icon: 'question',
      }).then(async confirmed => {
        if (confirmed) {
          this.saving = true
          try {
            console.log(item)
            await this.updateProductPriceStatus(item.id, newStatus)
            this.addNotification({type: 'success', msg: `Preço ${action}do com sucesso.`})
            this.had_item_updated = true
            this.nameChanged = true
            await this.getProductPrices()
          } catch (err) {
            console.log(err)
            this.addNotification({type: 'error', msg: `Erro ao ${action} preço.`})
          } finally {
            this.saving = false
          }
        }
      })
    },
    async updateProductPriceStatus(priceId, newStatus) {
      console.log(priceId, newStatus)
      try {
        // This will need to be implemented based on the available API endpoints
        // For now, we'll use a PUT request to update the status
        const response = await Api.ProductPrice.update({
          id: priceId,
          status_id: newStatus,
          active: newStatus === 1
        })
        return response.data
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    closeEditProductPickupLocation(){
      this.$router.push({name: 'BrandsList', params: {get_list: this.nameChanged}})
    }, 
    ...mapActions({
      getCompanies: 'Company/index',
    })
  },
  computed: {
    user_allowed() {
      return ['Manager', 'Director', 'SalesExecutive'].includes(this.profile?.included[0]?.attributes?.role?.data[0]?.attributes?.name)
    },
    activePrices() {
      if (!this.productPrices || this.productPrices.length === 0) return []
      
      return this.productPrices
        .map(price => ({
          id: price.id, // Include the ID for updates
          company_name: price.company_name, // Using the 'name' field from the response
          price: price.price,
          status: price.status_id,
          status_id: price.status_id
        }))
    },
    ...mapState({
      profile: state => state.User.oneUser,
      all_products: state => state.Supplier.all_products,
    })
  },
  watch: {
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
h3 {
  -webkit-text-fill-color: red !important;
}

h4 {
  -webkit-text-fill-color: red !important;
}
</style>
